<div class="weekly-scheduler">
  <div class="tableWrapper">
    <table class="center">
      <thead>
        <tr>
          <th class="weekday">
            {{ 'map.tools.sentryScheduleDialog.weeklyScheduler.dayOfWeek' | t }}
          </th>
          <th *ngFor="let h of halfHourHeaders" colspan="2" class="interval">{{ h }}</th>
        </tr>
      </thead>
      <tbody [ngClass]="{ isDrawing: isDrawing }">
        <tr *ngFor="let d of weekdays">
          <td class="weekday">
            <input
              type="checkbox"
              [checked]="weekdayhasCheck(d)"
              data-md-icheck
              (change)="toggleVisibility($event, d)"
            />
            {{ d.name }}

            <span class="checkmark"></span>
          </td>

          <td
            *ngFor="let h of d.intervals"
            class="interval"
            [class.selected]="h.selected"
            (mousedown)="startDrawing($event, d, h, !h.selected)"
            (mouseenter)="drawSelect(d, h)"
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="schedule-buttons">
    <button mat-button color="success" (click)="save()">
      {{ 'map.tools.sentryScheduleDialog.weeklyScheduler.setSchedule' | t }}
    </button>
  </div>
</div>
